import { faCheckSquare } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Review = ({
  copy,
  dataLinkId,
  isActive,
  setActive,
}: {
  copy: string;
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const iconLinkContainerClasses = `${styles.LeftNavIconLinkContainer} ${
    styles.IconLinkContainer
  } ${isActive ? styles.Active : ''}`;

  const reviewLink = `${styles.LinkRight} ${styles.ReviewLink} ${
    isActive ? styles.Active : ''
  }`;

  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faCheckSquare}
      iconClassName={styles.Icon}
      iconContainerClassName={iconLinkContainerClasses}
      textClassName={reviewLink}
      copy={copy}
      onClick={onClick}
    />
  );
};

export default Review;
